import DealCard from "./DealCard";

// Deals Board v2 — Single Kanban column with sticky header.
// Sticky header retains: stage name + deal count + total value.
export default function DealColumn({
  stage,
  deals,
  canEdit,
  canDelete,
  quotingDealId,
  onMoveStage,
  onCreateQuotation,
  onDelete,
}) {
  const totalValue = deals.reduce((sum, d) => sum + (Number(d.value) || 0), 0);

  return (
    <div
      data-testid={`deal-column-${stage.key}`}
      className="bg-white border border-slate-200 rounded-none flex flex-col min-h-[300px]"
    >
      <div
        data-testid={`deal-column-header-${stage.key}`}
        className="sticky top-[64px] z-20 bg-white px-3 py-2.5 border-b border-slate-200"
        style={{ borderTopWidth: "3px", borderTopColor: stage.color }}
      >
        <div className="flex items-center justify-between gap-2">
          <h4 className="font-semibold text-sm leading-tight truncate" style={{ fontFamily: "Outfit, sans-serif" }}>
            {stage.label}
          </h4>
          <span className="text-[10px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded-none" style={{ backgroundColor: `${stage.color}15`, color: stage.color }}>
            {deals.length}
          </span>
        </div>
        <p className="text-[11px] text-slate-500 mt-0.5 truncate" title={`${deals.length} deals · ₹${totalValue.toLocaleString("en-IN")}`}>
          ₹{totalValue.toLocaleString("en-IN")}
        </p>
      </div>

      <div className="p-2 space-y-2 flex-1">
        {deals.length === 0 ? (
          <div className="text-center text-[11px] text-slate-400 py-8">No deals</div>
        ) : (
          deals.map((deal, index) => (
            <DealCard
              key={deal.deal_id}
              deal={deal}
              index={index}
              stageKey={stage.key}
              stageColor={stage.color}
              canEdit={canEdit}
              canDelete={canDelete}
              quotingDealId={quotingDealId}
              onMoveStage={onMoveStage}
              onCreateQuotation={onCreateQuotation}
              onDelete={onDelete}
            />
          ))
        )}
      </div>
    </div>
  );
}
